import React from "react";
export default function EmailSettings() {
  return <h2 className="text-xl font-bold">Email Settings</h2>;
}
